<script lang="ts">
  export let lines: number = 3;
  export let height: string = '1rem';
  export let width: string = '100%';
  export let gap: string = '0.75rem';
</script>

<div class="skeleton-container" style="--skeleton-height: {height}; --skeleton-width: {width}; --skeleton-gap: {gap};">
  {#each Array(lines) as _, i}
    <div class="skeleton-line" style="width: {i === lines - 1 ? '75%' : '100%'};"></div>
  {/each}
</div>

<style>
  .skeleton-container {
    display: flex;
    flex-direction: column;
    gap: var(--skeleton-gap, 0.75rem);
    padding: 1rem;
  }

  .skeleton-line {
    height: var(--skeleton-height, 1rem);
    background: linear-gradient(
      90deg,
      #f0f0f0 25%,
      #e0e0e0 50%,
      #f0f0f0 75%
    );
    background-size: 200% 100%;
    animation: loading 1.5s ease-in-out infinite;
    border-radius: 4px;
  }

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
</style>

